import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'
import { setAutoFreeze } from 'immer'
import { isDevtoolsEnabled } from './utils/isDevtoolsEnabled'

setAutoFreeze(false)

export type ErrorType = 'PLAYER_CHANNEL_FAILED' | 'FATAL_CONNECTION_ERROR' | 'AUTHENTICATION_FAILED'

export interface AppError {
  type: ErrorType
  reason: string
  details?: string
  originalError?: any
}

interface ErrorState {
  fatalError?: AppError
}

export interface ErrorActions {
  setFatalError: (error: AppError) => void
  clearFatalError: () => void
}

type ErrorStore = ErrorState & { actions: ErrorActions }

export const useErrorStore = create<ErrorStore>()(
  devtools(
    immer((set) => ({
      fatalError: undefined,
      actions: {
        setFatalError: (error: AppError) => {
          // Single clean error log with all relevant info
          console.error(`[FATAL ERROR] ${error.type}: ${error.reason}${error.details ? ` (${error.details})` : ''}`, error.originalError || error)
          
          set(
            (state) => {
              state.fatalError = error
            },
            false,
            'setFatalError'
          )
        },
        clearFatalError: () => {
          set(
            (state) => {
              state.fatalError = undefined
            },
            false,
            'clearFatalError'
          )
        }
      }
    })),
    { name: 'ErrorStore', enabled: isDevtoolsEnabled() }
  )
)

export const useErrorActions = () => useErrorStore((state) => state.actions)

export const useGetFatalError = () => useErrorStore((state) => state.fatalError)

export const useHasFatalError = () => useErrorStore((state) => Boolean(state.fatalError))